module.exports = __webpack_public_path__ + "img/uk-flag.88035475.png";